import { render, staticRenderFns } from "./MyPost.vue?vue&type=template&id=5c99d1ba&"
import script from "./MyPost.vue?vue&type=script&lang=js&"
export * from "./MyPost.vue?vue&type=script&lang=js&"
import style0 from "./MyPost.vue?vue&type=style&index=0&id=5c99d1ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports